export default __webpack_public_path__ + "static/media/noysi.263de8c8.svg";